import 'reactjs-popup/dist/index.css';
import Popup from 'reactjs-popup';
import comment_image from '../images/comment.png'
import { url } from '../../weburl';
import axios from 'axios';
import { useState, useEffect, useContext } from 'react';
import CountryContext from '../../home/country_context';
import { Link } from 'react-router-dom';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import TagFacesIcon from '@mui/icons-material/TagFaces';
import { Button, ButtonBase } from '@mui/material';

export const CommentModal = (props) => {
    const contextData = useContext(CountryContext)
    const [commentContent, setCommentContent] = useState('')
    const afbr_context = useContext(CountryContext)

    useEffect(() => {

    }
        , [commentContent])
    const handleChange = (e) => {

        e.preventDefault()
        // const { name, value } = e.target
        setCommentContent(
            e.target.value
        )


    }
    const submitComment = (e) => {
        e.preventDefault()
        axios
            .post(`${url}api/comments`, {
                content: commentContent,
                user: contextData.user, post_id: props.post_id
            })
            .then((res) => {
                console.log('refreshing')
                afbr_context.refresh()
            })
            .catch((err) => console.log(err))
    }

    return (
        <Popup trigger={
            <button className='btn btn-default'>
                <img src={comment_image} alt="" width={'50px'} />
            </button>}
            position="right"
            modal
            nested
            closeOnDocumentClick>
            {close => (
                <div class="" >
                    <div class="">
                        {contextData.user ? <div class="modal-content">
                            <div class="modal-header">
                                <h5 class="modal-title" >Add a comment</h5>

                            </div>
                            <div class="modal-body">
                                <div className='container-fluid'>
                                    <div className='row align-items-center justify-content-start'>
                                        <div className='col-md-9'>
                                            <form className='text-dark' action="
                    ">                                                <div class="form-group text-left" >
                                                    <textarea class="form-control" id="postContent" onChange={e => handleChange(e)}
                                                        placeholder='Feel free!!!' rows="3"></textarea>
                                                </div>

                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="modal-footer">
                                <button type="button" class="btn btn-secondary" onClick={close} >Cancel</button>
                                <button type="button" class="btn btn-success" onClick={(e) => {
                                    submitComment(e)
                                    close()
                                }}>Comment   </button>
                            </div>
                        </div> :
                            <div className='py-5 bg-white'>
                                <p className='pt-5 pb-1'>Please log in/signup to be able to comment</p>
                                <div className='pb-4'>
                                    <Button><Link to='/login'><TagFacesIcon /> Login</Link> &nbsp;</Button>
                                    <Button><Link to='/sign_up'><TagFacesIcon />Sign up</Link></Button>
                                </div>

                                <button type="button" class="btn btn-danger" onClick={(e) => {
                                    close()
                                }}>Close   </button>
                            </div>}

                    </div>
                </div>

            )}
        </Popup>

    )
}
